import React, { Component } from 'react';

// Third Party Components
import { Marker } from 'react-google-maps';

// Components
import icon from '../../../../../../assets/images/icn_truck-empresa-2.png';

export default class NFMarker extends Component {
  render() {
    const { position, onClick } = this.props;

    return <Marker onClick={onClick} position={position} icon={icon} />;
  }
}
